<template>
  <div>
    <ApprovedBlock
      v-if="$route.path !== '/'"
      :layout="ctaLayout"
      :item="record('home-conversa') || null"
      :screen="screens['home-conversa']"
    />
    <footer class="site-footer">
      <div class="container footer-grid">
        <div>
          <svg class="footer-logo-filter" width="0" height="0" aria-hidden="true" focusable="false">
            <defs>
              <filter id="logo-branco-home" color-interpolation-filters="sRGB">
                <feComponentTransfer>
                  <feFuncR
                    type="table"
                    tableValues="1 0.05 0.1 0.15 0.2 0.25 0.3 0.35 0.4 0.45 0.5 0.55 0.6 0.65 0.7 0.75 0.8 0.85 0.9 0.95 1.0"
                  ></feFuncR>
                  <feFuncG
                    type="table"
                    tableValues="1 0.05 0.1 0.15 0.2 0.25 0.3 0.35 0.4 0.45 0.5 0.55 0.6 0.65 0.7 0.75 0.8 0.85 0.9 0.95 1.0"
                  ></feFuncG>
                  <feFuncB
                    type="table"
                    tableValues="1 0.05 0.1 0.15 0.2 0.25 0.3 0.35 0.4 0.45 0.5 0.55 0.6 0.65 0.7 0.75 0.8 0.85 0.9 0.95 1.0"
                  ></feFuncB>
                </feComponentTransfer>
              </filter>
            </defs>
          </svg>
          <svg
            v-if="footerLogo"
            class="footer-logo footer-logo-white"
            viewBox="0 0 2135 736"
            role="img"
            aria-label="GASS GROUP — 50 ANOS +"
            data-img="logo-rodape"
          >
            <title>GASS GROUP — 50 ANOS +</title>
            <image
              :href="footerLogo"
              width="2135"
              height="736"
              filter="url(#logo-branco-home)"
            ></image>
          </svg>

          <p v-if="text(record('home-rodape'), 'iti_nome')">
            {{ text(record('home-rodape'), 'iti_nome') }}
          </p>
          <RichText :value="contentValue(record('home-rodape'), 'iti_resumo1')" />
          <div
            v-if="socials.length"
            class="footer-socials"
            :aria-label="text(record('home-redes'), 'iti_nome') || undefined"
          >
            <ContentLink
              v-for="social in socials"
              :key="social.field"
              :to="social.link"
              class="social-link"
              :aria-label="social.label"
              :title="social.label"
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                  v-if="social.label.toLowerCase().includes('facebook')"
                  d="M14 21v-8h3l.5-4H14V7c0-1 .5-2 2-2h2V2h-3c-3 0-5 2-5 5v2H7v4h3v8"
                />
                <template v-else-if="social.label.toLowerCase().includes('instagram')">
                  <rect x="3" y="3" width="18" height="18" rx="5" />
                  <circle cx="12" cy="12" r="4" />
                  <circle cx="17.5" cy="6.5" r=".7" />
                </template>
                <template v-else-if="social.label.toLowerCase().includes('linkedin')">
                  <rect x="3" y="3" width="18" height="18" rx="2" />
                  <path d="M7 10v7M11 17v-7m0 3c0-4 6-4 6 0v4" />
                  <circle cx="7" cy="7" r=".6" class="social-fill" />
                </template>
                <template v-else>
                  <rect x="2" y="5" width="20" height="14" rx="4" />
                  <path d="m10 9 6 3-6 3z" />
                </template>
              </svg>
            </ContentLink>
          </div>
        </div>
        <nav aria-label="Institucional">
          <h2>Institucional</h2>
          <ul>
            <li v-for="group in institutionalGroups" :key="group.chave">
              <router-link :to="groupPath(group.chave)" class="text-link">{{
                group.nome
              }}</router-link>
            </li>
          </ul>
        </nav>
        <nav aria-label="Soluções">
          <h2>Soluções</h2>
          <ul>
            <li v-for="item in solutions" :key="itemId(item)">
              <router-link :to="detailPath('solucoes', item)" class="text-link">{{
                text(item, 'iti_nome')
              }}</router-link>
            </li>
          </ul>
        </nav>
        <nav aria-label="Explore">
          <h2>Explore</h2>
          <ul>
            <li v-for="group in exploreLinks" :key="group.path">
              <router-link :to="group.path" class="text-link">{{ group.label }}</router-link>
            </li>
            <li v-for="item in information" :key="itemId(item)">
              <router-link :to="detailPath('informacoes', item)" class="text-link">{{
                text(item, 'iti_nome')
              }}</router-link>
            </li>
          </ul>
        </nav>
      </div>
      <p v-if="errors.length" class="container" role="status">
        Parte das informações do rodapé está indisponível.
      </p>
      <section class="template-credit">
        <div class="container credit">
          <span>Desenvolvido por</span>
          <a
            class="text-link"
            href="https://www.avancedigital.com.br"
            target="_blank"
            rel="noopener noreferrer"
          >
            Avance Digital <ArrowIcon />
          </a>
        </div>
      </section>
    </footer>
    <aside v-if="whatsapp.link && whatsapp.label" class="whatsapp-floating">
      <ContentLink class="whatsapp-button" :to="whatsapp.link" :aria-label="whatsapp.label"
        ><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path
            d="M20.4 3.6A11.7 11.7 0 0 0 2 17.7L.4 23.6l6-1.6A11.7 11.7 0 0 0 20.4 3.6ZM12.1 21a9.7 9.7 0 0 1-4.9-1.3l-.4-.2-3.6 1 1-3.5-.3-.4A9.7 9.7 0 1 1 12.1 21Zm5.3-7.3c-.3-.1-1.7-.8-2-.9-.2-.1-.4-.1-.6.2l-.9 1.1c-.2.2-.3.2-.6.1a8 8 0 0 1-2.3-1.4 8.6 8.6 0 0 1-1.6-2c-.2-.3 0-.4.1-.6l.5-.5.3-.5c.1-.2 0-.4 0-.5l-.9-2.1c-.2-.5-.5-.5-.7-.5h-.6c-.2 0-.5.1-.7.3-.3.3-1 1-1 2.4s1 2.7 1.2 2.9c.1.2 2 3.1 4.9 4.3.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 1.9-1.4.3-.6.3-1.2.2-1.3-.1-.1-.3-.2-.6-.3Z"
          ></path></svg
        ><span>{{ whatsapp.label }}</span></ContentLink
      >
    </aside>
  </div>
</template>
<script>
import { groups, screens, groupPath } from '@/data/institutionalBlueprint';
import {
  loadScreens,
  firstImage,
  contentValue,
  plainText,
  safeLink,
  itemId,
  detailPath,
} from '@/services/contentApi';
import ApprovedBlock from './ApprovedBlock.vue';
import ArrowIcon from './ArrowIcon.vue';
import RichText from './RichText.vue';
import { approvedLayouts } from '@/data/approvedLayouts';
import ContentLink from './ContentLink.vue';
export default {
  name: 'PageFooter',
  components: { ApprovedBlock, ArrowIcon, RichText, ContentLink },
  data: () => ({ data: {}, errors: [], groups, screens }),
  computed: {
    footerLogo() {
      return firstImage(this.record('home-rodape'), screens['home-rodape']);
    },
    exploreLinks() {
      return [
        { path: '/setores', label: 'Setores de atuação' },
        { path: '/empresas-familiares', label: 'Empresas familiares' },
        { path: '/insights', label: 'GASS Insights' },
        { path: '/contato', label: 'Contato' },
      ];
    },
    ctaLayout() {
      return approvedLayouts.home.find((l) => l.type === 'cta');
    },
    institutionalGroups() {
      return groups.filter((g) =>
        [
          'o-grupo',
          'nossa-historia',
          'proposito',
          'empresas-do-grupo',
          'governanca',
          'perguntas-frequentes',
        ].includes(g.chave),
      );
    },
    supportGroups() {
      return groups.filter((g) => ['contato', 'insights', 'setores'].includes(g.chave));
    },
    solutions() {
      return this.data['solucoes-especialidades-lista'] || [];
    },
    information() {
      return this.data['informacoes-lgpd'] || [];
    },
    socials() {
      return screens['home-redes'].campos
        .filter((f) => f.campo.startsWith('iti_linkbtn'))
        .map((f) => ({
          field: f.campo,
          label: f.label,
          link: safeLink(contentValue(this.record('home-redes'), f.campo)),
        }))
        .filter((s) => s.link)
        .sort((a, b) => {
          const order = ['instagram', 'facebook', 'youtube', 'linkedin'];
          const rank = (s) => order.findIndex((name) => s.label.toLowerCase().includes(name));
          return rank(a) - rank(b);
        });
    },
    whatsapp() {
      const item = this.record('home-whatsapp');
      return {
        link: safeLink(contentValue(item, 'iti_linkbtn1')),
        label: this.text(item, 'iti_textobtn1'),
      };
    },
  },
  async created() {
    const result = await loadScreens(
      [
        'home-rodape',
        'home-redes',
        'home-whatsapp',
        'home-conversa',
        'informacoes-lgpd',
        'solucoes-especialidades-lista',
      ].map((k) => screens[k]),
    );
    this.data = result.data;
    this.errors = result.errors;
    window.__SHELL_READY__ = true;
  },
  methods: {
    contentValue,
    groupPath,
    itemId,
    detailPath,
    record(key) {
      return this.data[key]?.[0];
    },
    text(item, field) {
      return plainText(contentValue(item, field));
    },
  },
};
</script>
